import { TelemetryClient } from '@employee-experience/core';
import { v4 as uuid } from 'uuid';
function isTelemetryConfiguration(telemetryConfig) {
    return telemetryConfig && telemetryConfig.instrumentationKey !== undefined;
}
var TelemetryService = /** @class */ (function () {
    function TelemetryService(config, telemetryContext, correlationId) {
        this.correlationId = correlationId !== null && correlationId !== void 0 ? correlationId : uuid();
        if (isTelemetryConfiguration(config) && !TelemetryService.client) {
            var telemetryClient = new TelemetryClient(config, this.correlationId);
            telemetryContext !== undefined && telemetryClient.setContext(telemetryContext);
            TelemetryService.client = telemetryClient;
        }
        else if (!isTelemetryConfiguration(config)) {
            TelemetryService.client = config;
        }
    }
    TelemetryService.prototype.trackDependencyData = function (dependency) {
        TelemetryService.client.trackDependencyData(dependency);
    };
    TelemetryService.prototype.getChildInstance = function (config, correlationId, telemetryContext) {
        var childClient = TelemetryService.client.getChildInstance(config, correlationId !== null && correlationId !== void 0 ? correlationId : this.correlationId, telemetryContext);
        return new TelemetryService(childClient, telemetryContext, correlationId !== null && correlationId !== void 0 ? correlationId : this.correlationId);
    };
    TelemetryService.prototype.setContext = function (context) {
        TelemetryService.client.setContext(context);
    };
    TelemetryService.prototype.getCorrelationId = function () {
        return this.correlationId;
    };
    TelemetryService.prototype.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
        TelemetryService.client.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    };
    TelemetryService.prototype.stopTrackEvent = function (name, properties, measurements) {
        // Type check needed to call correct overload
        if (typeof name === 'string') {
            TelemetryService.client.stopTrackEvent(name, properties, measurements);
        }
        else {
            TelemetryService.client.stopTrackEvent(name, properties, measurements);
        }
        // Can't mark function as void
        return undefined;
    };
    TelemetryService.prototype.startTrackEvent = function (name) {
        // Type check needed to call correct overload
        if (typeof name === 'string') {
            TelemetryService.client.startTrackEvent(name);
        }
        else {
            TelemetryService.client.startTrackEvent(name);
        }
        // Can't mark function as void
        return undefined;
    };
    TelemetryService.prototype.trackEvent = function (event, customProperties) {
        TelemetryService.client.trackEvent(event, customProperties);
    };
    TelemetryService.prototype.trackCustomEvent = function (event, customProperties) {
        TelemetryService.client.trackCustomEvent(event, customProperties);
    };
    TelemetryService.prototype.trackException = function (exception, customProperties) {
        TelemetryService.client.trackException(exception, customProperties);
    };
    TelemetryService.prototype._onerror = function (exception) {
        TelemetryService.client._onerror(exception);
    };
    TelemetryService.prototype.trackTrace = function (trace, customProperties) {
        TelemetryService.client.trackTrace(trace, customProperties);
    };
    TelemetryService.prototype.trackMetric = function (metric, customProperties) {
        TelemetryService.client.trackMetric(metric, customProperties);
    };
    TelemetryService.prototype.startTrackPage = function (name) {
        TelemetryService.client.startTrackPage(name);
    };
    TelemetryService.prototype.stopTrackPage = function (name, url, customProperties) {
        TelemetryService.client.stopTrackPage(name, url, customProperties);
    };
    TelemetryService.prototype.addTelemetryInitializer = function (telemetryInitializer) {
        TelemetryService.client.addTelemetryInitializer(telemetryInitializer);
    };
    TelemetryService.prototype.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
        TelemetryService.client.trackPageViewPerformance(pageViewPerformance, customProperties);
    };
    TelemetryService.prototype.trackPageView = function (pageView) {
        TelemetryService.client.trackPageView(pageView);
    };
    return TelemetryService;
}());
export { TelemetryService };
